(() => {
  const root = document.getElementById('selsil-consent');
  if (!root) return;
  const banner = root.querySelector('.selsil-consent__banner');
  const dialog = root.querySelector('dialog');
  const suppressBanner = root.dataset.pageType === 'cart';
  const categories = ['preferences', 'analytics', 'marketing'];
  const failureDismissalKey = 'selsil-consent-failure-dismissed';
  let api;
  let pending = false;
  let dismissed = false;
  try { dismissed = window.sessionStorage.getItem(failureDismissalKey) === '1'; } catch {}
  let opener;
  let loadPromise;
  const errors = root.querySelectorAll('.selsil-consent__error');
  const clearErrors = () => errors.forEach((element) => { element.textContent = ''; });
  const dismissAfterFailure = () => {
    dismissed = true;
    try { window.sessionStorage.setItem(failureDismissalKey, '1'); } catch {}
    clearErrors();
    root.querySelector('[data-consent-status]').textContent = '';
    banner.hidden = true;
    if (dialog.open) dialog.close();
  };
  const current = () => api ? api.currentVisitorConsent() : {};
  const hasDecision = () => categories.every((category) => ['yes', 'no'].includes(current()[category]));
  const sync = () => categories.forEach((category) => {
    root.querySelector(`[name="${category}"]`).checked = !hasDecision() || current()[category] === 'yes';
  });
  const load = () => {
    const ready = (candidate) => typeof candidate?.currentVisitorConsent === 'function' &&
      typeof candidate?.setTrackingConsent === 'function';
    if (ready(api)) return Promise.resolve(api);
    if (loadPromise) return loadPromise;
    loadPromise = new Promise((resolve, reject) => {
      let attempts = 0;
      const find = () => {
        if (ready(window.Shopify?.customerPrivacy)) {
          api = window.Shopify.customerPrivacy;
          resolve(api);
        } else if (window.Shopify?.loadFeatures) {
          const timeout = setTimeout(() => reject(new Error('privacy_timeout')), 8000);
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            clearTimeout(timeout);
            if (error || !ready(window.Shopify.customerPrivacy)) reject(new Error('privacy_unavailable'));
            else { api = window.Shopify.customerPrivacy; resolve(api); }
          });
        } else if (attempts++ < 40) setTimeout(find, 100);
        else reject(new Error('privacy_unavailable'));
      };
      find();
    }).catch((error) => { loadPromise = undefined; throw error; });
    return loadPromise;
  };
  const busy = (value) => {
    pending = value;
    root.querySelectorAll('[data-consent-action], [data-consent-close], [data-consent-dismiss]').forEach((button) => { button.disabled = value; });
    root.setAttribute('aria-busy', String(value));
  };
  const save = async (action) => {
    if (pending) return;
    clearErrors();
    root.querySelector('[data-consent-status]').textContent = '';
    busy(true);
    const consent = {};
    categories.forEach((category) => {
      consent[category] = action === 'save' ? root.querySelector(`[name="${category}"]`).checked : action === 'accept';
    });
    consent.sale_of_data = consent.marketing;
    try {
      await load();
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('consent_timeout')), 8000);
        api.setTrackingConsent({ ...consent, metafields: [{ key: 'selsil_policy_version', value: root.dataset.policyVersion }] }, (result) => {
          clearTimeout(timeout);
          if (result?.error) reject(new Error('consent_rejected'));
          else resolve();
        });
      });
      const recorded = current();
      if (!categories.every((category) => recorded[category] === (consent[category] ? 'yes' : 'no'))) throw new Error('consent_mismatch');
      banner.hidden = true;
      if (dialog.open) dialog.close();
      root.querySelector('[data-consent-status]').textContent = root.dataset.saved;
    } catch { dismissAfterFailure(); }
    finally { busy(false); }
  };
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-selsil-consent-open]');
    if (openButton) {
      opener = openButton;
      clearErrors();
      sync();
      if (!dialog.open) dialog.showModal();
      load().then(sync).catch(dismissAfterFailure);
    }
    const actionButton = event.target.closest('[data-consent-action]');
    if (actionButton && root.contains(actionButton)) save(actionButton.dataset.consentAction);
    if (event.target.closest('[data-consent-close]') && !pending) dialog.close();
    if (event.target.closest('[data-consent-dismiss]') && !pending) {
      dismissed = true;
      banner.hidden = true;
    }
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog || pending) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('cancel', (event) => { if (pending) event.preventDefault(); });
  dialog.addEventListener('close', () => {
    if (opener?.isConnected) opener.focus();
    if (!suppressBanner && !hasDecision() && !dismissed) banner.hidden = false;
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (!pending && hasDecision()) { banner.hidden = true; sync(); }
  });
  load().then(() => { banner.hidden = suppressBanner || dismissed || hasDecision(); sync(); }).catch(dismissAfterFailure);
})();
